// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__11faH","link":"style_link__x-hP4","tooltipWrapper":"style_tooltipWrapper__34ZLs","text":"style_text__1OKRx"};